<script setup lang="ts">
import type { ArticleResource } from "@carnet/api/backoffice";

const props = defineProps<{
  articles: ArticleResource[];
}>();

const publishedArticles = computed(() => props.articles.filter((a) => a.publicationDate !== null));
</script>

<template>
  <AppSection v-if="publishedArticles.length" :ui="{ base: '' }">
    <h2 class="text-3xl sm:text-4xl font-semibold leading-tight mb-8">{{ $t("section.news.title") }}</h2>
    <ul class="border-t border-blue-400 divide-y divide-blue-400">
      <li v-for="article in publishedArticles" :key="article.code">
        <AppTileNews :article />
      </li>
    </ul>
  </AppSection>
</template>
